
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMapIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 339,
  height: 80,
  viewBox: "0 0 339 80",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "mapIcon_3b3a768c1accc486__c",
  d: "M0 0h81.31v338.978H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "mapIcon_3b3a768c1accc486__e",
  d: "M0 0h272.538v27.477H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "mapIcon_3b3a768c1accc486__g",
  d: "M0 0h8.886v75.17H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "mapIcon_3b3a768c1accc486__i",
  d: "M0 0h52.37v345.664H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "mapIcon_3b3a768c1accc486__k",
  d: "M0 0h114.478v403H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "mapIcon_3b3a768c1accc486__m",
  d: "M0 0h267.393v63.747H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "mapIcon_3b3a768c1accc486__o",
  d: "M0 0h.2v61.64H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "mapIcon_3b3a768c1accc486__q",
  d: "M0 0h73.167v30.775H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "mapIcon_3b3a768c1accc486__s",
  d: "M0 0h54.771v111.008H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "mapIcon_3b3a768c1accc486__u",
  d: "M0 0h63.519v68.693H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "mapIcon_3b3a768c1accc486__w",
  d: "M0 0h70.299v90.125H0z"
}), /*#__PURE__*/React.createElement("rect", {
  id: "mapIcon_3b3a768c1accc486__a",
  x: 0,
  y: 0,
  width: 339,
  height: 80,
  rx: 14
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mapIcon_3b3a768c1accc486__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mapIcon_3b3a768c1accc486__a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#D8D8D8",
  xlinkHref: "#mapIcon_3b3a768c1accc486__a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mapIcon_3b3a768c1accc486__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-light, #f9f3fb)",
  d: "M-4 350h367V-53H-4z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(128.886 11.022)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mapIcon_3b3a768c1accc486__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mapIcon_3b3a768c1accc486__c"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 3.005,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#mapIcon_3b3a768c1accc486__d)",
  d: "M81.311 346.122 0 0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4 -.702)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mapIcon_3b3a768c1accc486__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mapIcon_3b3a768c1accc486__e"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 3.005,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#mapIcon_3b3a768c1accc486__f)",
  d: "M-5.848 27.477 151.445 9.342 272.538 0"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 3.005,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m248.791.822 11.662 4.521 2.94 14.288M89.234 15.352l-.039-57.82-2.572-3.663-22.97-.55"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.206 -53)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mapIcon_3b3a768c1accc486__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mapIcon_3b3a768c1accc486__g"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 3.005,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#mapIcon_3b3a768c1accc486__h)",
  d: "M8.886 75.171 0-6.503"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 3.005,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M46.882 20.235 63.653 98.4l13.966 81.15 19.294 81.881 12.495 63.198"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(215.893 -53)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mapIcon_3b3a768c1accc486__j",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mapIcon_3b3a768c1accc486__i"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 6.01,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#mapIcon_3b3a768c1accc486__j)",
  d: "M52.37 345.664 0 57.885l5.88-59.35"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(242.17 -53)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mapIcon_3b3a768c1accc486__l",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mapIcon_3b3a768c1accc486__k"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 6.01,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#mapIcon_3b3a768c1accc486__l)",
  d: "m0 410.144 111.906-116.87 2.572-15.57-93.163-173.107 1.287-37.37 7.717-16.852L61.006-5.13"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4 51.688)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mapIcon_3b3a768c1accc486__n",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mapIcon_3b3a768c1accc486__m"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 3.005,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#mapIcon_3b3a768c1accc486__n)",
  d: "m267.393 0-36.836 11.797-81.515 16.312-160.219 35.638"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(147.353 -53)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mapIcon_3b3a768c1accc486__p",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mapIcon_3b3a768c1accc486__o"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 3.005,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#mapIcon_3b3a768c1accc486__p)",
  d: "M.1 61.641V-4.305"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 2.604,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m53.301 50.154 13.292-2.862M50.8 38.496l14.14-3.294 9.922 42.865 19.294-1.832 10.658 3.847 1.922 8.236M57.494 69.693l-20.485 3.794m67.663-59.915 4.736 29.324-4.043 4.396-8.269 2.93 3.308 15.571 28.482-5.495 2.389-3.847 29.951-6.96 6.533-42.418M124.108 61.22l4.011 22.342"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 2.604,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m106.736 26.352 12.043-1.225 5.33 5.312 21.498-3.663m6.799 24.912 6.243 25.387M218.33 18.28l-24.947 5.382-2.021 13.921 5.73 31.799m-1.656-9.186 15.771-2.829m-17.824-4.58-17.089 3.115m15.068-19.469-18.376 3.165m28.686-17.725-2.225-16.346m36.934 108.626 32.157-8.426 3.491-5.679 5.883-21.645m-24.258 14.135-4.863-36.173m-17.715 31.953-13.989-7.32-34.913 5.861-4.043-5.862-1.837-7.453m97.022-6.468 12.862-7.694h11.393l46.79 66.91m-51.935-67.46-3.308-35.17L301.43-7.846 287.28-26.53"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(289.833 23.662)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mapIcon_3b3a768c1accc486__r",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mapIcon_3b3a768c1accc486__q"
})), /*#__PURE__*/React.createElement("path", {
  d: "M.02 0c-.734 0 18.376 10.808 18.376 10.808l24.99 2.015 36.75 17.952",
  stroke: "#FFF",
  strokeWidth: 2.604,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#mapIcon_3b3a768c1accc486__r)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(308.229 34.47)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mapIcon_3b3a768c1accc486__t",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mapIcon_3b3a768c1accc486__s"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 2.604,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  mask: "url(#mapIcon_3b3a768c1accc486__t)",
  d: "m0 0 2.205 17.22 59.536 93.788"
})), /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-bright, #e3d2e9)",
  d: "m229.858 58.74-6.615-37.735 36.934-2.381-.918 31.69z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4 41.888)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mapIcon_3b3a768c1accc486__v",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mapIcon_3b3a768c1accc486__u"
})), /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-bright, #e3d2e9)",
  mask: "url(#mapIcon_3b3a768c1accc486__v)",
  d: "M-3.735 68.693 63.52 54.222l-4.043-23.447-20.58 3.846-.735-5.312 20.03-3.664L52.86 0-3.735 3.847z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-light, #f9f3fb)",
  d: "m50.147 22.104 3.124 13.19 13.414-3.115 9.74 42.682 16.537-1.282 4.226-6.412-3.859-18.501 9.188-3.664 3.675-3.847-3.675-24.363zm41.896-10.441v-40.3h52.002V5.984z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(292.701 -53)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mapIcon_3b3a768c1accc486__x",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mapIcon_3b3a768c1accc486__w"
})), /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-light, #f9f3fb)",
  mask: "url(#mapIcon_3b3a768c1accc486__x)",
  d: "M33.26-.366 6.798 36.636l5.513 8.06L0 75.104l16.722 9.526 23.704 1.832 7.901 3.663 27.93-46.711-2.572-43.78z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-light, #f9f3fb)",
  d: "m278.001 68.083 37.119 69.426 24.622-12.273-43.182-62.832h-9.187z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151 41.707c-2.207 0-3.996-1.762-3.996-3.936 0-2.173 1.79-3.935 3.996-3.935 2.207 0 3.996 1.762 3.996 3.935 0 2.174-1.79 3.936-3.996 3.936m8.998-3.936C159.946 32.927 155.93 29 151 29c-.065 0-.128.008-.192.01-4.842.1-8.756 3.98-8.807 8.761l-.002.094c0 2.756 2.34 7.538 3.734 10.143.914 1.705 1.883 3.339 2.73 4.602 1.232 1.84 1.777 2.302 2.345 2.377.063.008.127.013.192.013.642 0 1.187-.358 2.552-2.39.845-1.258 1.813-2.893 2.727-4.604 1.389-2.6 3.72-7.378 3.72-10.141l-.002-.094",
  fill: "var(--theme-primary, #810ea9)"
})))));

      const __svgRaw = "<svg width=\"339\" height=\"80\" viewBox=\"0 0 339 80\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <defs>\r\n        <path id=\"o69cn777tc\" d=\"M0 0h81.31v338.978H0z\"/>\r\n        <path id=\"ro62ekcdhe\" d=\"M0 0h272.538v27.477H0z\"/>\r\n        <path id=\"4d78iguyag\" d=\"M0 0h8.886v75.17H0z\"/>\r\n        <path id=\"uz3xi5xy4i\" d=\"M0 0h52.37v345.664H0z\"/>\r\n        <path id=\"elmar0gx2k\" d=\"M0 0h114.478v403H0z\"/>\r\n        <path id=\"to3qsofu6m\" d=\"M0 0h267.393v63.747H0z\"/>\r\n        <path id=\"6ej5h13j3o\" d=\"M0 0h.2v61.64H0z\"/>\r\n        <path id=\"mtsrn2rtxq\" d=\"M0 0h73.167v30.775H0z\"/>\r\n        <path id=\"clv1j7xkzs\" d=\"M0 0h54.771v111.008H0z\"/>\r\n        <path id=\"mw2t02k1tu\" d=\"M0 0h63.519v68.693H0z\"/>\r\n        <path id=\"5frwdns3pw\" d=\"M0 0h70.299v90.125H0z\"/>\r\n        <rect id=\"5687bf0iqa\" x=\"0\" y=\"0\" width=\"339\" height=\"80\" rx=\"14\"/>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <mask id=\"959iq3hm4b\" fill=\"#fff\">\r\n            <use xlink:href=\"#5687bf0iqa\"/>\r\n        </mask>\r\n        <use fill=\"#D8D8D8\" xlink:href=\"#5687bf0iqa\"/>\r\n        <g mask=\"url(#959iq3hm4b)\">\r\n            <path fill=\"var(--theme-light, #f9f3fb)\" d=\"M-4 350h367V-53H-4z\"/>\r\n            <g transform=\"translate(128.886 11.022)\">\r\n                <mask id=\"1vt9i6d4md\" fill=\"#fff\">\r\n                    <use xlink:href=\"#o69cn777tc\"/>\r\n                </mask>\r\n                <path stroke=\"#FFF\" stroke-width=\"3.005\" stroke-linecap=\"round\" stroke-linejoin=\"round\" mask=\"url(#1vt9i6d4md)\" d=\"M81.311 346.122 0 0\"/>\r\n            </g>\r\n            <g transform=\"translate(-4 -.702)\">\r\n                <mask id=\"gx7pg04skf\" fill=\"#fff\">\r\n                    <use xlink:href=\"#ro62ekcdhe\"/>\r\n                </mask>\r\n                <path stroke=\"#FFF\" stroke-width=\"3.005\" stroke-linecap=\"round\" stroke-linejoin=\"round\" mask=\"url(#gx7pg04skf)\" d=\"M-5.848 27.477 151.445 9.342 272.538 0\"/>\r\n            </g>\r\n            <path stroke=\"#FFF\" stroke-width=\"3.005\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m248.791.822 11.662 4.521 2.94 14.288M89.234 15.352l-.039-57.82-2.572-3.663-22.97-.55\"/>\r\n            <g transform=\"translate(21.206 -53)\">\r\n                <mask id=\"c1c0utpq6h\" fill=\"#fff\">\r\n                    <use xlink:href=\"#4d78iguyag\"/>\r\n                </mask>\r\n                <path stroke=\"#FFF\" stroke-width=\"3.005\" stroke-linecap=\"round\" stroke-linejoin=\"round\" mask=\"url(#c1c0utpq6h)\" d=\"M8.886 75.171 0-6.503\"/>\r\n            </g>\r\n            <path stroke=\"#FFF\" stroke-width=\"3.005\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M46.882 20.235 63.653 98.4l13.966 81.15 19.294 81.881 12.495 63.198\"/>\r\n            <g transform=\"translate(215.893 -53)\">\r\n                <mask id=\"jmcvi6axwj\" fill=\"#fff\">\r\n                    <use xlink:href=\"#uz3xi5xy4i\"/>\r\n                </mask>\r\n                <path stroke=\"#FFF\" stroke-width=\"6.01\" stroke-linecap=\"round\" stroke-linejoin=\"round\" mask=\"url(#jmcvi6axwj)\" d=\"M52.37 345.664 0 57.885l5.88-59.35\"/>\r\n            </g>\r\n            <g transform=\"translate(242.17 -53)\">\r\n                <mask id=\"4w7zy7ozal\" fill=\"#fff\">\r\n                    <use xlink:href=\"#elmar0gx2k\"/>\r\n                </mask>\r\n                <path stroke=\"#FFF\" stroke-width=\"6.01\" stroke-linecap=\"round\" stroke-linejoin=\"round\" mask=\"url(#4w7zy7ozal)\" d=\"m0 410.144 111.906-116.87 2.572-15.57-93.163-173.107 1.287-37.37 7.717-16.852L61.006-5.13\"/>\r\n            </g>\r\n            <g transform=\"translate(-4 51.688)\">\r\n                <mask id=\"ibc6gnkrsn\" fill=\"#fff\">\r\n                    <use xlink:href=\"#to3qsofu6m\"/>\r\n                </mask>\r\n                <path stroke=\"#FFF\" stroke-width=\"3.005\" stroke-linecap=\"round\" stroke-linejoin=\"round\" mask=\"url(#ibc6gnkrsn)\" d=\"m267.393 0-36.836 11.797-81.515 16.312-160.219 35.638\"/>\r\n            </g>\r\n            <g transform=\"translate(147.353 -53)\">\r\n                <mask id=\"guxo562m3p\" fill=\"#fff\">\r\n                    <use xlink:href=\"#6ej5h13j3o\"/>\r\n                </mask>\r\n                <path stroke=\"#FFF\" stroke-width=\"3.005\" stroke-linecap=\"round\" stroke-linejoin=\"round\" mask=\"url(#guxo562m3p)\" d=\"M.1 61.641V-4.305\"/>\r\n            </g>\r\n            <path stroke=\"#FFF\" stroke-width=\"2.604\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m53.301 50.154 13.292-2.862M50.8 38.496l14.14-3.294 9.922 42.865 19.294-1.832 10.658 3.847 1.922 8.236M57.494 69.693l-20.485 3.794M104.672 13.572l4.736 29.324-4.043 4.396-8.269 2.93 3.308 15.571 28.482-5.495 2.389-3.847 29.951-6.96 6.533-42.418M124.108 61.22l4.011 22.342\"/>\r\n            <path stroke=\"#FFF\" stroke-width=\"2.604\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m106.736 26.352 12.043-1.225 5.33 5.312 21.498-3.663M152.406 51.688l6.243 25.387M218.33 18.28l-24.947 5.382-2.021 13.921 5.73 31.799M195.436 60.196l15.771-2.829M193.383 52.787l-17.089 3.115M191.362 36.433l-18.376 3.165M201.672 21.873l-2.225-16.346M236.381 114.153l32.157-8.426 3.491-5.679 5.883-21.645M253.654 92.538l-4.863-36.173M231.076 88.318l-13.989-7.32-34.913 5.861-4.043-5.862-1.837-7.453M273.316 67.076l12.862-7.694h11.393l46.79 66.91M292.426 58.832l-3.308-35.17L301.43-7.846 287.28-26.53\"/>\r\n            <g transform=\"translate(289.833 23.662)\">\r\n                <mask id=\"goha2dp4zr\" fill=\"#fff\">\r\n                    <use xlink:href=\"#mtsrn2rtxq\"/>\r\n                </mask>\r\n                <path d=\"M.02 0c-.734 0 18.376 10.808 18.376 10.808l24.99 2.015 36.75 17.952\" stroke=\"#FFF\" stroke-width=\"2.604\" stroke-linecap=\"round\" stroke-linejoin=\"round\" mask=\"url(#goha2dp4zr)\"/>\r\n            </g>\r\n            <g transform=\"translate(308.229 34.47)\">\r\n                <mask id=\"wbwzacunst\" fill=\"#fff\">\r\n                    <use xlink:href=\"#clv1j7xkzs\"/>\r\n                </mask>\r\n                <path stroke=\"#FFF\" stroke-width=\"2.604\" stroke-linecap=\"round\" stroke-linejoin=\"round\" mask=\"url(#wbwzacunst)\" d=\"m0 0 2.205 17.22 59.536 93.788\"/>\r\n            </g>\r\n            <path fill=\"var(--theme-bright, #e3d2e9)\" d=\"m229.858 58.74-6.615-37.735 36.934-2.381-.918 31.69z\"/>\r\n            <g transform=\"translate(-4 41.888)\">\r\n                <mask id=\"j54uw1ae5v\" fill=\"#fff\">\r\n                    <use xlink:href=\"#mw2t02k1tu\"/>\r\n                </mask>\r\n                <path fill=\"var(--theme-bright, #e3d2e9)\" mask=\"url(#j54uw1ae5v)\" d=\"M-3.735 68.693 63.52 54.222l-4.043-23.447-20.58 3.846-.735-5.312 20.03-3.664L52.86 0-3.735 3.847z\"/>\r\n            </g>\r\n            <path fill=\"var(--theme-light, #f9f3fb)\" d=\"m50.147 22.104 3.124 13.19 13.414-3.115 9.74 42.682 16.537-1.282 4.226-6.412-3.859-18.501 9.188-3.664 3.675-3.847-3.675-24.363zM92.043 11.663v-40.3h52.002V5.984z\"/>\r\n            <g transform=\"translate(292.701 -53)\">\r\n                <mask id=\"rl8ex61sjx\" fill=\"#fff\">\r\n                    <use xlink:href=\"#5frwdns3pw\"/>\r\n                </mask>\r\n                <path fill=\"var(--theme-light, #f9f3fb)\" mask=\"url(#rl8ex61sjx)\" d=\"M33.26-.366 6.798 36.636l5.513 8.06L0 75.104l16.722 9.526 23.704 1.832 7.901 3.663 27.93-46.711-2.572-43.78z\"/>\r\n            </g>\r\n            <path fill=\"var(--theme-light, #f9f3fb)\" d=\"m278.001 68.083 37.119 69.426 24.622-12.273-43.182-62.832h-9.187z\"/>\r\n            <path d=\"M151 41.707c-2.207 0-3.996-1.762-3.996-3.936 0-2.173 1.79-3.935 3.996-3.935 2.207 0 3.996 1.762 3.996 3.935 0 2.174-1.79 3.936-3.996 3.936m8.998-3.936C159.946 32.927 155.93 29 151 29c-.065 0-.128.008-.192.01-4.842.1-8.756 3.98-8.807 8.761l-.002.094c0 2.756 2.34 7.538 3.734 10.143.914 1.705 1.883 3.339 2.73 4.602 1.232 1.84 1.777 2.302 2.345 2.377.063.008.127.013.192.013.642 0 1.187-.358 2.552-2.39.845-1.258 1.813-2.893 2.727-4.604 1.389-2.6 3.72-7.378 3.72-10.141l-.002-.094\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/mapIcon.3b3a768c1accc486fd0df6299bc88389.svg"),
        {
          React: SvgMapIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      